export default __webpack_public_path__ + "static/media/featured-headphones.45272fd7.webp";